export { GalaxyTooltipDirective as GalaxyTooltip } from './src/directive/tooltip.directive';
export { DEFAULT_TOOLTIP_POSITIONS, TooltipComponent } from './src/tooltip.component';
